// extracted by mini-css-extract-plugin
export default {"wrapper":"R1-z","message":"S1-z","image":"T1-z"};